export default __webpack_public_path__ + "static/media/arrow.95615b66.svg";